import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05b83586")

_pushScopeId("data-v-05b83586")
const _hoisted_1 = { class: "translucent py-8 px-10 p-a br-lg c-white d-f z-1" }
const _hoisted_2 = { class: "flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", { feedback: _ctx.onDrawingStateChange }, undefined, true),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_Pic, {
        src: "icons/mouse",
        width: "24",
        height: "24",
        class: "mr-10"
      }),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_t, {
          as: "p",
          path: _ctx.textPath
        }, null, 8, ["path"])
      ])
    ], 512), [
      [_vShow, _ctx.textPath]
    ])
  ]))
})